import React, {useEffect} from 'react'

import { CircularProgress } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';
import classnames from "classnames"

import "styles/components/popup.sass"
import {$moment, httpClient} from 'funcs'
import { useRoute } from 'react-router5'

import StoreProps from 'utils/types/storeProps';
import moment from "moment";
import {TariffUpgradeType} from "../../methods/TariffUpgradeType";
import {TransactionStatus, TransactionStatusHelper} from "../../util/TransactionStatus";
import { loadSelf } from 'methods/loadSelf';
import { ServiceType } from '../../types/ServiceTypes';
import { trackPaymentFinish } from '../../methods/trackGoal';

interface Props extends StoreProps {
    $store: any,
    $commitToStore: Function,
    setPaymentNotification: Function,
    transactionId: string,
    success: any,
    onSuccessfulPayment?: Function,
    returnRoute?: string,
}

let PaymentStatus: any = ({$store, $commitToStore, setPaymentNotification, transactionId, success, onSuccessfulPayment, returnRoute = 'packages-v2'}: Props) => {
    const $router = useRoute();

    const [confirmed, setConfirmed] = React.useState<string>("")
    const [balance, setBalance] = React.useState<any>({})

    useEffect(() => {
        let cancelled = false
        let timeoutId: ReturnType<typeof setTimeout> | null = null
        const POLL_INTERVAL_MS = 2000
        const MAX_POLLS = 60

        function fetchStatus(pollCount: number) {
            if (cancelled) return
            httpClient.get(`get-transaction-info/${transactionId}`).then((res) => {
                if (cancelled) return
                const status = res.data.status
                setConfirmed(status)
                setBalance(res.data)

                if (TransactionStatusHelper.isSuccess(status)) {
                    const priceKopecks = Number(res.data?.price)
                    trackPaymentFinish(transactionId, {
                        order_price: Number.isFinite(priceKopecks) ? priceKopecks / 100 : undefined,
                        currency: 'RUB',
                        transaction_type: res.data?.transaction_type,
                    })
                    loadSelf({ $store, $commitToStore })
                    if (onSuccessfulPayment) {
                        onSuccessfulPayment()
                    }
                    return
                }
                if (TransactionStatusHelper.isFailed(status)) return
                if (pollCount < MAX_POLLS) {
                    timeoutId = setTimeout(() => fetchStatus(pollCount + 1), POLL_INTERVAL_MS)
                }
            }).catch(() => {
                if (cancelled) return
                if (pollCount < MAX_POLLS) {
                    timeoutId = setTimeout(() => fetchStatus(pollCount + 1), POLL_INTERVAL_MS)
                }
            })
        }

        fetchStatus(0)
        return () => {
            cancelled = true
            if (timeoutId) clearTimeout(timeoutId)
        }
    }, [transactionId])

    function getUpgradeTitles(upgrades: string[]): string {
        return upgrades
            .map(upgrade => {
                try {
                    const upgradeType = upgrade as TariffUpgradeType;
                    return TariffUpgradeType.getTitle(upgradeType);
                } catch {
                    return '';
                }
            })
            .filter(Boolean)
            .join(' и ');
    }

    return <div className={classnames('popup')} style={{}} >
        <div className="wrapper">
            <div className="container center" style={{padding: "15px"}}>
                <div style={{marginTop: '30px'}}>
                    {
                        TransactionStatusHelper.isSuccess(confirmed) &&
                        <CheckCircleOutlineIcon fontSize="large" sx={{color: "#4EBA28", alignSelf: "center", fontSize: 70, margin: '2px'}}/>
                    }
                    {
                        (success === "false" || TransactionStatusHelper.isFailed(confirmed)) &&
                        <ErrorIcon sx={{ fontSize: 70, color: "#E22631", alignSelf: "center" }}/>
                    }
                </div>

                <div className="H3_21" style={{marginTop: '30px'}}>
                    {
                        TransactionStatusHelper.isSuccess(confirmed) ? "Оплачено" : 
                        TransactionStatusHelper.isFailed(confirmed) ? "Не получилось оплатить" :
                        success === "true" ? "Оплачено" : "Не получилось оплатить"
                    }
                </div>

                {
                    // TransactionStatusHelper.isSuccess(confirmed) &&
                    <div>
                        <div className='confirmation'>
                            {
                                !TransactionStatusHelper.isSuccess(confirmed) &&
                                <>
                                    <div className="Body_15" style={{marginBottom: "15px"}}> Идёт подтверждение, подождите... </div>
                                    <CircularProgress sx={{color: "#1FA3EE", alignSelf: "center"}} />
                                </>
                            }

                            {
                                TransactionStatusHelper.isSuccess(confirmed) && balance &&
                                <div>
                                    {
                                        balance.transaction_type === 'upgrade' && balance.tariff_upgrades?.length > 0 &&
                                        <div className="Body_15">
                                            {getUpgradeTitles(balance.tariff_upgrades)} успешно подключены
                                        </div>
                                    }
                                    {
                                        balance.transaction_type === 'subscription' &&
                                        <div className="Body_15">Безлимитная подписка активирована</div>
                                    }
                                    {
                                        balance.transaction_type === 'add_card' &&
                                        <div className="Body_15">Карта привязана. Следующее списание подписки пройдёт с новой карты</div>
                                    }
                                    {
                                        balance.transaction_type === 'package' &&
                                        <div className="Body_15">Ваш баланс: {balance.balance} договоров</div>
                                    }
                                    {
                                        balance.transaction_type === ServiceType.TEMPLATE_CONFIGURATION &&
                                        <div className="Body_15">Оплата за настройку шаблона получена</div>
                                    }
                                    {
                                        balance.transaction_type === ServiceType.REALTY_CONFIGURATION &&
                                        <div className="Body_15">Оплата за настройку интеграции с RealtyCalendar получена</div>
                                    }
                                    {
                                        balance.transaction_type === ServiceType.AMO_CONFIGURATION &&
                                        <div className="Body_15">Оплата за настройку интеграции с AmoCRM получена</div>
                                    }
                                    {
                                        balance.transaction_type === ServiceType.BITRIX_CONFIGURATION &&
                                        <div className="Body_15">Оплата за настройку интеграции с Bitrix получена</div>
                                    }
                                    {
                                        balance.transaction_type === ServiceType.LEGAL_CHECKS &&
                                        <div className="Body_15">Юридические проверки успешно куплены</div>
                                    }
                                    {
                                        balance.transaction_type === ServiceType.AI_TEMPLATE_CONFIGURATION &&
                                        <div className="Body_15">Оплата настройки шаблона ИИ получена</div>
                                    }
                                    {
                                        balance.transaction_type === 'package_v2' &&
                                        <div className="Body_15">Корзина успешно оплачена</div>
                                    }
                                    {
                                        balance.transaction_type === 'cart' &&
                                        <div className="Body_15">Корзина успешно оплачена</div>
                                    }

                                    <hr className="newHR"/>
                                    <div>
                                        <div className="commonLabel">Информация о покупке</div>
                                        <div className="commonSubtitle" style={{marginTop: "15px"}}>
                                            {
                                                balance.transaction_type === 'upgrade' ? 
                                                    `Стоимость улучшения: ${balance.price/100} рублей` :
                                                balance.transaction_type === ServiceType.TEMPLATE_CONFIGURATION ?
                                                    `Стоимость настройки шаблона: ${balance.price/100} рублей` :
                                                balance.transaction_type === ServiceType.REALTY_CONFIGURATION ?
                                                    `Стоимость настройки интеграции с RealtyCalendar: ${balance.price/100} рублей` :
                                                balance.transaction_type === ServiceType.AMO_CONFIGURATION ?
                                                    `Стоимость настройки интеграции с AmoCRM: ${balance.price/100} рублей` :
                                                balance.transaction_type === ServiceType.BITRIX_CONFIGURATION ?
                                                    `Стоимость настройки интеграции с Bitrix: ${balance.price/100} рублей` :
                                                balance.transaction_type === ServiceType.LEGAL_CHECKS ?
                                                    `Стоимость проверок: ${balance.price/100} рублей` :
                                                balance.transaction_type === ServiceType.AI_TEMPLATE_CONFIGURATION ?
                                                    `Стоимость настройки шаблона ИИ: ${balance.price/100} рублей` :
                                                balance.transaction_type === 'package_v2' ?
                                                    `Стоимость: ${balance.price/100} рублей` :
                                                balance.transaction_type === 'cart' ?
                                                    `Стоимость: ${balance.price/100} рублей` :
                                                balance.transaction_type === 'add_card' ?
                                                    'Проверили карту, 1 ₽ вернём' :
                                                    `Цена: ${balance.price/100} рублей`
                                            }
                                        </div>

                                        {
                                            balance.transaction_type === 'subscription' && balance.next_subscription_charge_date &&
                                            <div className="commonSubtitle">
                                                Следующая дата списания {$moment(balance.next_subscription_charge_date).format('LL')}
                                                {balance.tariff_upgrades?.length > 0 && 
                                                    ` (включая ${getUpgradeTitles(balance.tariff_upgrades)})`}
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === 'package' &&
                                            <>
                                                <div className="commonSubtitle">Вы приобрели: {balance.added_amount} договоров</div>
                                                {balance.tariff_upgrades?.length > 0 && 
                                                    <div className="commonSubtitle">С функцией {getUpgradeTitles(balance.tariff_upgrades)}</div>}
                                            </>
                                        }
                                        {
                                            balance.transaction_type === 'upgrade' && balance.tariff_upgrades?.length > 0 &&
                                            <div className="commonSubtitle">
                                                {balance.tariff?.type === 'subscription' ? 
                                                    `${getUpgradeTitles(balance.tariff_upgrades)} будут активны до следующего списания` :
                                                    `${getUpgradeTitles(balance.tariff_upgrades)} активированы для текущего пакета договоров`}
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === ServiceType.TEMPLATE_CONFIGURATION &&
                                            <div className="commonSubtitle">
                                                Наши специалисты приступят к настройке вашего шаблона в ближайшее время.<br/>
                                                Мы свяжемся с вами для уточнения деталей.
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === ServiceType.REALTY_CONFIGURATION &&
                                            <div className="commonSubtitle">
                                                Наши специалисты приступят к настройке интеграции с Realty в ближайшее время.<br/>
                                                Мы свяжемся с вами для уточнения деталей.
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === ServiceType.AMO_CONFIGURATION &&
                                            <div className="commonSubtitle">
                                                Наши специалисты приступят к настройке интеграции с AmoCRM в ближайшее время.<br/>
                                                Мы свяжемся с вами для уточнения деталей.
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === ServiceType.BITRIX_CONFIGURATION &&
                                            <div className="commonSubtitle">
                                                Наши специалисты приступят к настройке интеграции с Bitrix в ближайшее время.<br/>
                                                Мы свяжемся с вами для уточнения деталей.
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === ServiceType.LEGAL_CHECKS &&
                                            <div className="commonSubtitle">
                                                На ваш баланс добавлено {balance.legal_checks_count || 1} юридических проверок
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === 'package_v2' &&
                                            <div className="commonSubtitle">
                                                Купленные услуги активированы
                                            </div>
                                        }
                                        {
                                            balance.transaction_type === 'cart' &&
                                            <div className="commonSubtitle">
                                                Купленные услуги активированы
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }

                {
                    (success === "false" || TransactionStatusHelper.isFailed(confirmed)) &&
                    <div className='confirmation'>
                        <div className="Body_15">
                            {TransactionStatusHelper.isFailed(confirmed) 
                                ? `Оплата не удалась: ${TransactionStatusHelper.getStatusText(confirmed)}`
                                : "Не удалось произвести оплату. Попробуйте еще раз или поменяйте способ оплаты"
                            }
                        </div>
                    </div>
                }

                <button
                    className="new withTitle _wa"
                    style={{marginTop: "30px"}}
                    onClick={() => {
                        setPaymentNotification(false);
                        $router.router.navigate(returnRoute)
                    }}
                >
                    Вернуться назад
                </button>
            </div>


        </div>
    </div>
}


export default PaymentStatus


